import {
    addDoc,
    collection,
    doc,
    getDoc,
    onSnapshot,
    serverTimestamp,
    updateDoc,
  } from 'firebase/firestore'
  import db from '../../../../services/firebase'
  
  export const getActiveFrameworks = (currentUser: any, setActiveFrameworks: any) => {
    try {
      const tenantId = currentUser?.tenantId || ''
      const tenantRef = doc(db, 'tenants', tenantId)
      const testsCollectionRef = collection(tenantRef, 'active_frameworks')
  
      const unsubscribe = onSnapshot(testsCollectionRef, (snapshot) => {
        const frameworksData = snapshot.docs.map((doc) => ({
          ...doc.data(),
          id: doc.id,
          frameworks: doc.data().frameworks,
        }))
        const frameworks = frameworksData[0]?.frameworks || []
        setActiveFrameworks(frameworks)
      })
  
      return unsubscribe
    } catch (error) {
      console.error('Error getting frameworks:', error)
    }
  }
  
  export const getPersonnels = (currentUser: any, setPersonnels: any) => {
    try {
      const tenantId = currentUser?.tenantId || ''
      if (!tenantId) return
  
      const tenantRef = doc(db, 'tenants', tenantId)
      const PolicyRef = collection(tenantRef, 'employees')
  
      const unsubscribe = onSnapshot(PolicyRef, (snapshot) => {
        const personnelsData = snapshot.docs
          .map((doc) => ({
            ...doc.data(),
            id: doc.id,
            end_date: doc.data().end_date,
          }))
          .filter((data) => !data.end_date)
        setPersonnels(personnelsData)
      })
  
      return unsubscribe
    } catch (error) {
      console.error('Error getting personnels:', error)
    }
  }
  
  export const getControls = async (currentUser: any, id: string, setControls: any, setTests: any) => {
    try {
      const tenantId = currentUser?.tenantId || ''
      const tenantRef = doc(db, 'tenants', tenantId)
      const controlsCollectionRef = collection(tenantRef, 'controls')
  
      const unsubscribe = onSnapshot(controlsCollectionRef, (snapshot) => {
        const controlsData = snapshot.docs.map((doc) => ({
          ...doc.data(),
          id: doc.id,
        })).filter((data) => data.id === id)
        setControls(controlsData)
      })
  
      const testsCollectionRef = collection(tenantRef, 'tests')
      const unsubscribee = onSnapshot(testsCollectionRef, (snapshot) => {
        const testsData = snapshot.docs.map((doc) => ({
          ...doc.data(),
          id: doc.id,
          status: doc.data().status,
        }))
        setTests(testsData)
      })
  
      return [unsubscribe, unsubscribee]
    } catch (error) {
      console.error('Error getting controls:', error)
    }
  }
  
  export const updateControlStatus = async (control: any, currentUser: any,specificTests:any,specificdocuments:any) => {
    if (!currentUser || !currentUser.tenantId) return
    if (control.control_evidence_status === 'Deactivated') return
    const tenantId = currentUser.tenantId
    const testDocRef = doc(db, 'tenants', tenantId, 'controls', control.id)
    try {
      let controlTest = calculateDocumentStatus(specificTests, control.test_id) || '0/0'
      let controlDocument = calculateDocumentStatus(specificdocuments, control.document_id) || '0/0'

      controlTest = controlTest.trim() === 'N/A' ? '0/0' : controlTest
      controlDocument = controlDocument.trim() === 'N/A' ? '0/0' : controlDocument
  
      const [currentCount, totalCount] = controlTest.split('/').map(Number)
      const [currentCount1, totalCount1] = controlDocument.split('/').map(Number)
  
      const newStatus =
        currentCount === totalCount && currentCount1 === totalCount1 ? 'OK' : 'Unhealthy'
  
      await updateDoc(testDocRef, {
        control_evidence_status: newStatus,
      })
  
      if (newStatus === 'OK') {
        const currentDate = new Date()
        const todaysDate = `${
          currentDate.getMonth() + 1
        }/${currentDate.getDate()}/${currentDate.getFullYear()}`
  
        const activitiesRef = collection(db, 'tenants', tenantId, 'activities')
        await addDoc(activitiesRef, {
          message: `Control ${control.control_title || control.id} status updated to OK`,
          timestamp: serverTimestamp(),
          tenantId: currentUser.tenantId,
          uid: currentUser.uid,
          username: currentUser.userName,
          action: 'Control status updated',
          target: 'Controls',
          email: currentUser.email,
          date: todaysDate,
        })
      }
    } catch (error) {
      console.error('Error updating control status: ', error)
    }
  }

  export const processControlValues = (
    inputString: string | undefined, 
    inputString2: string | undefined, 
    testIds: string[] = [], 
    documentIds: string[] = [],
    tests: any[]
  ): string => {
    let testNum = 0
    let testDen = 0
    
    if (testIds.length > 0) {
      const activeTests = testIds
        .map(id => tests.find(test => test.id === id))
        .filter(test => test && test.status !== 'Deactivated')
      
      testDen = activeTests.length
      testNum = activeTests.filter(test => test.status === 'Pass').length
    }
  
    let docNum = 0
    let docDen = 0
    
    if (documentIds.length > 0) {
      const activeDocuments = documentIds
        .map(id => tests.find(test => test.id === id))
        .filter(test => test && test.status !== 'Deactivated')
      
      docDen = activeDocuments.length
      docNum = activeDocuments.filter(test => test.status === 'Pass').length
    }
  
    const totalNum = testNum + docNum
    const totalDen = testDen + docDen
  
    if (totalDen === 0) {
      return '0/0'
    }
  
    return `${totalNum}/${totalDen}`
  }
  
  export const deleteNote = async (
      currentUser: any,
      id: string,
      selectedNoteIndex: number
  ): Promise<void> => {
      const tenantId = currentUser?.tenantId || ''
      const testDocRef = doc(db, `tenants/${tenantId}/controls/${id}`)
  
      const docSnap = await getDoc(testDocRef)
      const currentNotes = docSnap.data()?.notes || []
  
      const updatedNotes = currentNotes.filter((_, i) => i !== selectedNoteIndex)
  
      await updateDoc(testDocRef, {
        notes: updatedNotes,
      })
  }
  
  export const deleteTest = async (
      currentUser: any,
      id: string,
      selectedTestIndex: number
  ): Promise<void> => {
      const tenantId = currentUser?.tenantId || ''
      const testDocRef = doc(db, `tenants/${tenantId}/controls/${id}`)
  
      const docSnap = await getDoc(testDocRef)
      const currentdocument = docSnap.data()?.document_id || []
  
      const updatedRisks = currentdocument.filter((_, i) => i !== selectedTestIndex)
  
      await updateDoc(testDocRef, {
        document_id: updatedRisks,
      })
  }
  
  export const deletePlatform = async (
      currentUser: any,
      id: string,
      selectedPlatformIndex: number
  ): Promise<void> => {
      const tenantId = currentUser?.tenantId || ''
      const testDocRef = doc(db, `tenants/${tenantId}/controls/${id}`)
  
      const docSnap = await getDoc(testDocRef)
      const currentdocument = docSnap.data()?.test_id || []
  
      const updatedRisks = currentdocument.filter((_, i) => i !== selectedPlatformIndex)
  
      await updateDoc(testDocRef, {
        test_id: updatedRisks,
      })
  }

  export const calculateDocumentStatus = (documents: any[], docIds: string[]) => {
    if (!docIds || docIds.length === 0) return ' N/A '

    const activeTests = documents.filter((doc) => doc.status !== 'Deactivated')
    const totalActiveDocs = activeTests.length
    const passingDocs = activeTests.filter((doc) => doc.status === 'Pass').length

    if (passingDocs === 0 && totalActiveDocs === 0) {
      return ' N/A '
    }

    return `${passingDocs}/${totalActiveDocs}`
  }